import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatBadgeModule} from '@angular/material/badge';
import {MatRadioModule} from '@angular/material/radio';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {StringStrictPipe} from './pipes/string-strict.pipe';
import {RomanNumberPipe} from './pipes/roman-number.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SanitizePipe} from './pipes/sanitize.pipe';
import {EmptyStateComponent} from './components/empty-state/empty-state.component';
import {ErrorStateComponent} from './components/error-state/error-state.component';
import {ListStringPipe} from './pipes/list-to-string.pipe';
import {DateTimezonePipe} from './pipes/dateTimezone';
import {StripTagsPipe} from './pipes/strip-tags.pipe';
import {MatInputModule} from '@angular/material/input';
import {MatTabsModule} from '@angular/material/tabs';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FormControlExceptionDirective} from './directives/form-control-exception/form-control-exception';
import {CarregandoComponent} from './components/carregando/carregando.component';
import {LegendaIqarComponent} from './components/legenda-iqar/legenda-iqar.component';
import {ClimaComponent} from './components/clima/clima.component';
import {DadosEstacaoComponent} from './components/dados-estacao/dados-estacao.component';
import {GraficoIqarComponent} from './components/grafico-iqar/grafico-iqar.component';
import {GraficoPoluenteComponent} from './components/grafico-poluente/grafico-poluente.component';
import {EstacaoFonteComponent} from '../mapa/estacao/estacao-fonte/estacao-fonte.component';
import {BuscarEstacoesComponent} from '../painel/buscar-estacoes/buscar-estacoes.component';
import {EstacaoSaibaComponent} from '../mapa/estacao/estacao-saiba/estacao-saiba.component';
import {IqarPipe} from './pipes/iqar.pipe';
import {SelecaoAutomaticaComponent} from '../definicoes/selecao-automatica/selecao-automatica.component';
import {AtivarGpsComponent} from '../definicoes/ativar-gps/ativar-gps.component';
import {RelatorioComponent} from './components/relatorio/relatorio.component';
import {EstacaoCardComponent} from './components/widget/estacao-card/estacao-card.component';
import {VirtualScrollerModule} from '@iharbeck/ngx-virtual-scroller';

const MATERIAL = [
  MatProgressSpinnerModule,
  MatInputModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatIconModule,
  MatRippleModule,
  MatCheckboxModule,
  MatBadgeModule,
  MatRadioModule,
  MatProgressBarModule,
  MatTabsModule,
  DragDropModule
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    StringStrictPipe,
    RomanNumberPipe,
    SanitizePipe,
    EmptyStateComponent,
    ErrorStateComponent,
    ListStringPipe,
    DateTimezonePipe,
    StripTagsPipe,
    FormControlExceptionDirective,
    CarregandoComponent,
    LegendaIqarComponent,
    ClimaComponent,
    DadosEstacaoComponent,
    GraficoIqarComponent,
    GraficoPoluenteComponent,
    EstacaoFonteComponent,
    EstacaoSaibaComponent,
    BuscarEstacoesComponent,
    SelecaoAutomaticaComponent,
    AtivarGpsComponent,
    IqarPipe,
    RelatorioComponent,
    EstacaoCardComponent
  ],
    imports: [
        CommonModule,
        MATERIAL,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        VirtualScrollerModule
    ],
  exports: [
    MATERIAL,
    StringStrictPipe,
    RomanNumberPipe,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    SanitizePipe,
    EmptyStateComponent,
    ErrorStateComponent,
    ListStringPipe,
    DateTimezonePipe,
    StripTagsPipe,
    FormControlExceptionDirective,
    CarregandoComponent,
    LegendaIqarComponent,
    ClimaComponent,
    DadosEstacaoComponent,
    GraficoIqarComponent,
    GraficoPoluenteComponent,
    EstacaoFonteComponent,
    EstacaoSaibaComponent,
    BuscarEstacoesComponent,
    SelecaoAutomaticaComponent,
    AtivarGpsComponent,
    IqarPipe,
    RelatorioComponent,
    EstacaoCardComponent
  ]
})
export class SharedModule {
}
